import { formatDateTime } from '@myap/ui-library/esm/date'
import { Error, Loader, SortableTable, BasicText } from '../common'
import { fetchGeneratedAPIDs } from '../../actions/generateAPID'
import {
  getGeneratedAPIDsData,
  getGeneratedAPIDsStatusProps,
  getGenerateAPIDStatusProps,
} from '../../selectors/generateAPID'
import { generateShortUID } from '../../utils/common'
import tableUtilStyles from '../../assets/style/scss/table-utils.scss'

const mapStateToProps = state => {
  const { fetching, fetched, error } = getGeneratedAPIDsStatusProps(state)
  const { submitted } = getGenerateAPIDStatusProps(state)
  const data = getGeneratedAPIDsData(state)
  return {
    submitted,
    fetching,
    fetched,
    error,
    data,
  }
}

const StandardRow = ({
  data: {
    batchNumber,
    studentId,
    testingAiCode,
    attendingAiCode,
    academicYear,
    createdDate,
    createdBy,
  },
  index,
}) => (
  <tr className={`${index % 2 ? tableUtilStyles.even : tableUtilStyles.odd}`}>
    <th scope="row">{batchNumber}</th>
    <td>{studentId}</td>
    <td>{testingAiCode}</td>
    <td>{attendingAiCode}</td>
    <td>{academicYear}</td>
    <td>{formatDateTime(createdDate)}</td>
    <td>{createdBy}</td>
  </tr>
)

const virtualRow = ({ data, index }) => (
  <tr className={`${index % 2 ? tableUtilStyles.even : tableUtilStyles.odd}`}>
    <th scope="row">{data[index].batchNumber}</th>
    <td>{data[index].studentId}</td>
    <td>{data[index].testingAiCode}</td>
    <td>{data[index].attendingAiCode}</td>
    <td>{data[index].academicYear}</td>
    <td>{formatDateTime(data[index].createdDate)}</td>
    <td>{data[index].createdBy}</td>
  </tr>
)

export default connect(mapStateToProps, { fetchGeneratedAPIDs })(
  ({ submitted, fetching, error, data, fetchGeneratedAPIDs }) => {
    const [filterAiCode, setFilterAiCode] = useState('')
    const [visibleData, setVisibleData] = useState([])

    const headerColumns = [
      {
        headerText: { title: 'Batch/Serial Number' },
        headerAttributes: { id: 'batchNumberCol' },
      },
      {
        headerText: { title: 'AP ID' },
        headerAttributes: { id: 'studentId' },
      },
      {
        headerText: { title: 'Testing AI' },
        headerAttributes: { id: 'testingAiCodeCol' },
        key: ['testingAiCode'],
        sortDir: ['asc'],
      },
      {
        headerText: { title: 'Attending School' },
        headerAttributes: { id: 'attendingAiCodeCol' },
      },
      {
        headerText: { title: 'Academic Year' },
        headerAttributes: { id: 'educationPeriodCdCol' },
        key: ['educationPeriodCd'],
        sortDir: ['desc'],
      },
      {
        headerText: { title: 'Created On' },
        headerAttributes: { id: 'createdDateCol' },
        key: ['createdDate'],
        sortDir: ['desc'],
        defaultSort: true,
      },
      {
        headerText: { title: 'Created By' },
        headerAttributes: { id: 'createdByCol' },
        key: ['createdBy'],
        sortDir: ['asc'],
      },
    ]

    useEffect(() => {
      fetchGeneratedAPIDs()
    }, [submitted])

    useEffect(() => {
      if (filterAiCode.length > 0) {
        setVisibleData(data.filter(item => item?.testingAiCode.startsWith(filterAiCode)))
      } else {
        setVisibleData(data)
      }
    }, [filterAiCode, data])

    const handleChangeAiCodeFilter = e => {
      setFilterAiCode(e.target.value)
    }

    if (error) return <Error message={error} />

    if (fetching) return <Loader />

    if (data.length > 0)
      return (
        <>
          <div className="row">
            <div className="col-md-4 col-sm-12 cb-spacerv-sm-top">
              <h2 className="cb-spacerv-xs-top">Generated AP IDs</h2>
            </div>
            <div className="col-md-8 col-sm-12 cb-spacerv-sm-top">
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ width: '200px' }}>
                  <BasicText
                    name="aiCodeFilter"
                    value={filterAiCode}
                    srOnlyLabel={true}
                    placeholder="AI Code"
                    maxlength="8"
                    isSearchBox={true}
                    input={{
                      name: 'filterAiCode',
                      value: filterAiCode,
                      onChange: e => handleChangeAiCodeFilter(e),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              {visibleData.length === 0 && data.length > 0 ? (
                <p>There are no generated AP IDs that match the selected filters.</p>
              ) : (
                <SortableTable
                  tableAttributes={{
                    id: 'generatedAPIDsTable',
                    summary:
                      'Table listing all AP IDs that have been generated. By default, most recently generated AP ID is first.',
                    className: `table cb-no-table-border ${tableUtilStyles['som-striped']}`,
                  }}
                  tableCaption={{
                    caption: 'A view of generated AP IDs.',
                    srOnly: true,
                  }}
                  data={visibleData}
                  virtualRow={virtualRow}
                  StandardRow={StandardRow}
                  virtualKey={(index, data) => {
                    return `${data[index].studentId}_${generateShortUID()}`
                  }}
                  standardKey={data => `${data.studentId}_${generateShortUID()}`}
                  columns={headerColumns}
                  tbody={true}
                  itemSize={49}
                />
              )}
            </div>
          </div>
        </>
      )

    return (
      <div className="row">
        <div className="col-xs-12 cb-spacerv-sm-top">
          <p>No AP IDs have been generated yet.</p>
        </div>
      </div>
    )
  }
)
